/**
 * =============================================================================
 * setera-web
 * =============================================================================
 * Copyright (c) 2026 HG Digital/Setera
 * Todos os direitos reservados.
 *
 * Este software é confidencial e de propriedade da HG Digital/Setera.
 * Seu uso está sujeito aos termos do contrato de licença.
 * -----
 * Criado em : 18-09-2026 11:50:03
 * Autor     : Diego Brock
 * Projeto   : setera-web
 * Versão    : 1.0.0
 * =============================================================================
 */

import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

/** Dados do diálogo de confirmação de reenvio/cancelamento. */
export interface CommandHistoryConfirmDialogData {
  title: string;
  message: string;
  confirmLabel: string;
  /** Quando true, o botão de confirmação usa cor warn (cancelar). */
  warn?: boolean;
}

/**
 * Confirmação de reenviar/cancelar via MatDialog (mesmo stack do popup de comandos).
 * Evita SweetAlert2 atrás do overlay CDK (z-index 9999).
 */
@Component({
  selector: 'app-command-history-confirm-dialog',
  templateUrl: './command-history-confirm-dialog.component.html',
  styleUrls: ['./command-history-confirm-dialog.component.scss']
})
export class CommandHistoryConfirmDialogComponent {
  title: string;
  message: string;
  confirmLabel: string;
  warn: boolean;

  constructor(
    private dialogRef: MatDialogRef<CommandHistoryConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: CommandHistoryConfirmDialogData
  ) {
    this.title = (data && data.title) || 'Confirmar';
    this.message = (data && data.message) || '';
    this.confirmLabel = (data && data.confirmLabel) || 'Confirmar';
    this.warn = !!(data && data.warn);
  }

  /**
   * Fecha sem confirmar.
   */
  cancel(): void {
    this.dialogRef.close(false);
  }

  /**
   * Fecha confirmando a ação.
   */
  confirm(): void {
    this.dialogRef.close(true);
  }
}
